<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc2"><a href="#/v1/1cover">Peter Pan</a></p>
<p class="toc2"><span href="#/v2/1cover" title="Link target outside of Sample">The Wonderful Wizard of Oz</span></p>
<p class="toc2"><span href="#/v3/cover" title="Link target outside of Sample">Alice’s Adventures in Wonderland</span></p>
<p class="toc2"><span href="#/v4/cover" title="Link target outside of Sample">The Swiss Family Robinson</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// maintoc.vue?51eefef0